import React from 'react';
import ExamStepper from './ExamStepper';
import ViewQuestionsPeek from './ViewQuestionsPeek';
import { isReadOnly, kickerFor, stepState, titleFor } from './steps';
import { CloseButton, Header, Kicker, Title, TitleBlock } from './style';

const CloseIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
);

/**
 * Wizard header (spec §6, tplA 415–446): ✕ · kicker · title · View
 * question(s) · stepper.
 */
export default function WizardHeader({ exam, step, onClose, onGo }) {
  const questions = isReadOnly('questions', exam);
  const questionsEditable =
    (!questions.readOnly || questions.wordingEditable) &&
    stepState('questions', exam) !== 'LOCKED';
  return (
    <Header data-testid="exam-wizard-header">
      <CloseButton
        type="button"
        title="Close"
        aria-label="Close"
        onClick={onClose}
      >
        <CloseIcon />
      </CloseButton>
      <TitleBlock>
        <Kicker data-testid="exam-wizard-kicker">{kickerFor(exam)}</Kicker>
        {exam && (
          <Title data-testid="exam-wizard-title">{titleFor(exam)}</Title>
        )}
      </TitleBlock>
      {exam && (
        <>
          <ViewQuestionsPeek
            exam={exam}
            canEdit={step !== 'questions' && questionsEditable}
            onEdit={() => onGo?.('questions')}
          />
          <ExamStepper exam={exam} viewing={step} onGo={onGo} />
        </>
      )}
    </Header>
  );
}
